import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import OrderLst from "@/views/OrderLst.vue";
import StoreView from "@/views/OrderDetailsView.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/order',
        name: 'order',
        component: OrderLst
    },
    {
        path: '/order/detail',
        name: 'orderDetail',
        component: StoreView
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
